<template>
    <v-container fluid style="height: auto">
        <v-row>
            <v-col cols="4" class="pa-0 mx-1">
                <v-select
                        label="Если условие совпало, то переходим к"
                        v-model="modelItems[0]"
                        :items="[{value: 1, text: 'Ничего не делаем'}, {value: 2, text: 'Сообщению'}, {value: 3, text: 'Событию'}, {value: 4, text: 'Изменение переменной'}]"
                        hide-details
                        @change="changeTypeIf"
                ></v-select>
            </v-col>
            <v-col cols="5" class="pa-0 mx-1" v-if="modelItems[0] !== 4">
                <v-select
                        v-model="modelItems[1]"

                        :items="if_items"
                        item-text="title"
                        item-value="id"
                        hide-details
                        @change="changeItems"
                ></v-select>
            </v-col>
            <v-col cols="4" class="pa-0 mx-1" v-if="modelItems[0] === 4">
                <v-combobox

                        v-model="variablesIfItems"
                        chips
                        multiple
                        :items="if_items"
                        item-text="title"
                        item-value="id"
                        hide-details

                >
                    <template v-slot:selection="{ index, item }">
                        <v-chip
                                :key="index"
                                close
                                @click:close="removeIfItem(index)"
                        >
                            {{ item.title }}
                        </v-chip>
                    </template>
                </v-combobox>
            </v-col>
            <v-col cols="3" class="pa-0 mx-1" v-if="modelItems[0] === 4">
                <v-text-field
                        v-model="modelItems[1][1]"
                        hide-details
                        @change="changeItems"
                ></v-text-field>
            </v-col>
            <v-col cols="4" class="pa-0 mx-1">
                <v-select
                        label="Если условие не совпало, то переходим к"
                        v-model="modelItems[2]"
                        :items="[{value: 1, text: 'Ничего не делаем'}, {value: 2, text: 'Сообщению'}, {value: 3, text: 'Событию'}, {value: 4, text: 'Изменение переменной'}, {value: 5, text: 'Действие'}]"
                        hide-details
                        @change="changeTypeElse"
                ></v-select>
            </v-col>
            <v-col cols="5" class="pa-0 mx-1" v-if="modelItems[2] !== 4 && modelItems[2] !== 5">

                <v-select
                        v-model="modelItems[3]"
                        :items="else_items"
                        item-text="title"
                        item-value="id"
                        hide-details
                        @change="changeItems"
                ></v-select>
            </v-col>
            <v-col cols="3" class="pa-0 mx-1" v-if="modelItems[2] === 5">
                <v-select
                        v-model="modelItems[3][0]"
                        :items="elseController"
                        hide-details
                        @change="changeItems"
                ></v-select>
            </v-col>
            <v-col cols="4" class="pa-0 mx-1" v-if="modelItems[2] === 5">

                <v-select
                        v-model="modelItems[3][1]"
                        :items="elseControllerActions"
                        hide-details
                        @change="changeItems"
                ></v-select>
            </v-col>
            <v-col cols="4" class="pa-0 mx-1" v-if="modelItems[2] === 4">
                <v-combobox

                        v-model="variablesElseItems"
                        chips
                        multiple
                        :items="else_items"
                        item-text="title"
                        item-value="id"
                        hide-details
                >
                    <template v-slot:selection="{ index, item }">
                        <v-chip
                                :key="index"
                                close
                                @click:close="removeElseItem(index)"
                        >
                            {{ item.title }}
                        </v-chip>
                    </template>
                </v-combobox>
            </v-col>
            <v-col cols="3" class="pa-0 mx-1" v-if="modelItems[2] === 4">
                <v-text-field
                        v-model="modelItems[3][1]"
                        hide-details
                        @change="changeItems"
                ></v-text-field>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import messageConstants from '@/components/bot/message/messageConstants'
export default {
    name: 'ModuleVariablesIfElseSelects',
    data() {
        return {
        }
    },
    props: ['label', 'itemsInModule', 'params', 'load', 'modelItems', 'methodId', 'index', 'indexCell'],
    computed: {
        ...mapState(['messages', 'events', 'scenarios']),
        if_items() {
            switch (this.modelItems[0]) {
            case 2: // СОобщения
                return this.messages.messages
            case 3: // События
                return this.events.events
            case 4: // Изменение переменных
                return this.scenarios.variables
            case 5:
                return messageConstants.controllerItems.map(controller => {
                    return { title: controller.text, id: controller.value }
                })
            default: // СОобщения
                return []
            }
        },
        else_items() {
            switch (this.modelItems[2]) {
            case 2: // СОобщения
                return this.messages.messages
            case 3: // События
                return this.events.events
            case 4: // Изменение переменных
                return this.scenarios.variables
            default: // СОобщения
                return []
            }
        },
        elseController() {
            return messageConstants.controllerItems
        },
        elseControllerActions() {
            let actions = messageConstants.actions
            return actions.hasOwnProperty(this.modelItems[3][0]) ? actions[this.modelItems[3][0]] : []
        },
        variablesIfItems: {
            get() {
                if (+this.modelItems[0] === 4) {
                    let variables = []
                    this.modelItems[1][0].forEach((item) => {
                        let variable = this.scenarios.variables.find(variable => variable.id === item)
                        if (variable) {
                            variables.push(variable)
                        }
                    })
                    return variables
                } else return []
            },
            set(values) {
                if (+this.modelItems[0] === 4) {
                    let variables = []
                    values.forEach((element) => {
                        variables.push(element.id)
                    })
                    this.modelItems[1][0] = variables
                }
            }
        },
        variablesElseItems: {
            get() {
                if (+this.modelItems[2] === 4) {
                    let variables = []
                    this.modelItems[3][0].forEach((item) => {
                        let variable = this.scenarios.variables.find(variable => variable.id === item)
                        if (variable) {
                            variables.push(variable)
                        }
                    })
                    return variables
                } else return []
            },
            set(values) {
                if (+this.modelItems[2] === 4) {
                    let variables = []
                    values.forEach((element) => {
                        variables.push(element.id)
                    })
                    this.modelItems[3][0] = variables
                }
            }
        }
    },
    methods: {
        changeTypeElse() {
            if (+this.modelItems[2] === 1) {
                this.modelItems[3] = 0
            }
            if (+this.modelItems[2] === 4 || +this.modelItems[2] === 5) { // Если 4 тип тогда нужно изменить на массив
                Vue.set(this.modelItems, 3, [[], ''])
            }
            console.log(this.modelItems[0], this.modelItems)
            this.$emit('updateItems', { items: this.modelItems, methodId: this.methodId, index: this.index, indexCell: this.indexCell })
        },
        changeTypeIf() {
            if (+this.modelItems[0] === 1) {
                this.modelItems[1] = 0
            }
            if (+this.modelItems[0] === 4 || +this.modelItems[0] === 5) {
                Vue.set(this.modelItems, 1, [[], ''])
            }
            this.$emit('updateItems', { items: this.modelItems, methodId: this.methodId, index: this.index, indexCell: this.indexCell })
        },
        changeItems() {
            this.$emit('updateItems', { items: this.modelItems, methodId: this.methodId, index: this.index, indexCell: this.indexCell })
        },
        removeIfItem(index) {
            this.modelItems[1][0].splice(index, 1)
            this.changeItems()
        },
        removeElseItem(index) {
            this.modelItems[3][0].splice(index, 1)
            this.changeItems()
        }
    },
    created() {
        this.$store.dispatch('messages/messageAll', this.$route.params['pathMatch'])
        this.$store.dispatch('events/eventAll', this.$route.params['pathMatch'])
        this.$store.dispatch('scenarios/variablesAll', this.$route.params['pathMatch'])
    }

}
</script>

<style scoped>
    .container {
        height: auto;
    }
    .v-text-field {
        font-size: 0.9em;
    }
</style>
